module.exports = __webpack_public_path__ + "static/media/leftBlack.0de0ce7f.svg";